module.exports = __webpack_public_path__ + "static/media/ot_4.e39e2e70.JPG";